import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import {ApplicationState} from "../../../store";
import {APIState} from "../../../store/API/types";
import {getCameraFromQuid} from "../../../utils";
import {errorBookmarkForPane, initBookmarkForPane} from "../../../store/bookmarks/actions";
import {LayoutState} from "../../../store/layouts/types";
import {openWarningException} from "../../../store/layouts/actions";
import service from "../../../services";
import { setPlaybackmode } from '../../../store/timeline/actions';


interface Props {
    files: any[],
    timeBounds: {
        start: number,
        end: number
    },
    i: number
}

const BookmarkThumbnailComponent: React.FC<Props> = ({files, timeBounds, i}) => {
    const {token, cameras} = useSelector<ApplicationState, APIState>(state => state.API);
    const { checkedPane } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const [hoverSrc, setHoverSrc] = useState<string | null>(null);
    const dispatch = useDispatch();


    const handler = (e: React.MouseEvent, videoUrl: string, bkmUrl: string, id: string) => {
        e.preventDefault();
        e.stopPropagation();

        if (checkedPane === null) {
            return dispatch(openWarningException('Please check the pane for view bookmark'))
        }

        dispatch(setPlaybackmode('pause', true));

        const cam = getCameraFromQuid(cameras, videoUrl);

        cam ? dispatch(initBookmarkForPane(checkedPane, bkmUrl, cam.id, cam.name, timeBounds))
            : dispatch(errorBookmarkForPane(checkedPane, id))
    };

    const onMouseMove = (e: React.MouseEvent, src: string) => {
        const el = document.getElementById('bkm-thumbnail__hover');

        if(!hoverSrc) {
            setHoverSrc(src);
            if(el && el instanceof HTMLImageElement) {
                el.src = src;
                el.style.display = 'block'
            }
        }

        if (hoverSrc) {
            if (el) {
                el.style.left = (e.clientX - 170) + 'px';
                el.style.top = (e.clientY) + 'px';
            }
        }

    };

    const onMouseLeave = () => {
        if (hoverSrc) {
            setHoverSrc(null);
            const el = document.getElementById('bkm-thumbnail__hover');

            if (el) {
                el.style.display = 'none'
            }
        }
    };


    return (
        <div className={i++ % 2 === 0 ? 'bookmarks-content__item thumbnail darkcol' : 'bookmarks-content__item thumbnail litecol' }>
            {
                files.map(({id, thumbnail, video_url, playback_url}) => {
                    const src = service.getBkmThumbnailSrc(encodeURI(thumbnail), token);
                    return (
                        <div key={'thumbnail' + id}>
                            {
                                <img src={src}
                                     alt="id"
                                     width='30px'
                                     className='bkm-thumbnail'
                                     onMouseMove={(e) => onMouseMove(e, src)}
                                     onMouseLeave={onMouseLeave}
                                     onClick={(e) => handler(e, video_url, playback_url, id)}
                                />
                            }
                        </div>
                    )
                })
            }
        </div>
    );
};

export default BookmarkThumbnailComponent;